import { OnCallPeriod } from '../models/request-and-responses/rest-api/enums/onCallPeriod';

interface IOnCallPeriodLV {
    label: string;
    value: OnCallPeriod;
}

export class OnCallPeriods {
    private static readonly [OnCallPeriod.Morning]: IOnCallPeriodLV = {
        label: 'Mattina',
        value: OnCallPeriod.Morning
    };
    private static readonly [OnCallPeriod.Afternoon]: IOnCallPeriodLV = {
        label: 'Pomeriggio',
        value: OnCallPeriod.Afternoon
    };
    private static readonly [OnCallPeriod.MorningAndAfternoon]: IOnCallPeriodLV = {
        label: 'Mattina e pomeriggio',
        value: OnCallPeriod.MorningAndAfternoon
    };

    static get list(): IOnCallPeriodLV[] {
        return [
            OnCallPeriods[OnCallPeriod.Morning],
            OnCallPeriods[OnCallPeriod.Afternoon],
            OnCallPeriods[OnCallPeriod.MorningAndAfternoon]
        ];
    }
}



// WEBPACK FOOTER //
// ./src/app/helpers/onCallPeriods.ts